import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { AlertaModalService } from '../../services/util/alerta-modal.service';
import { Constants } from '../../constants/constants';
import { PoliticaTratamientoDatosPersonalesComponent } from '../util/modal-politica/politica-tratamiento-datos-personales/politica-tratamiento-datos-personales.component';
import { FuncionalidadService } from '../../services/funcionalidad.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements AfterViewInit, OnInit {
  @ViewChild(PoliticaTratamientoDatosPersonalesComponent)
  politicaTratamientoDatosPersonalesComponent!: PoliticaTratamientoDatosPersonalesComponent;

  constructor(
    private readonly alertaModalService: AlertaModalService,
    private readonly router: Router
  ) { }

  ngOnInit(): void {
    let funcionalidades = JSON.parse(
      sessionStorage.getItem(Constants.FUNCIONALIDADES) || '[]'
    );
    if (
      funcionalidades.length > 0 &&
      funcionalidades[0]?.url &&
      funcionalidades[0]?.url !== '/'
    ) {
      this.router.navigateByUrl(funcionalidades[0]?.url);
    }
  }

  ngAfterViewInit(): void {
    const infoInicioSesion = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
    const tipoUsuario = infoInicioSesion.tipoUsuario.Id;
    if (
      (tipoUsuario == 1 || tipoUsuario == 2) &&
      infoInicioSesion.aceptoDatos == false
    ) {
      this.politicaTratamientoDatosPersonalesComponent.abrirModal();
    }
  }

  alertaConfirmar() {
    this.alertaModalService.confirmacion(
      '¿Desea eliminar el expediente?',
      'Eliminar',
      () => {
      },
      () => {
      }
    );
  }

  async alertaExito() {
    await this.alertaModalService.exito('Expediente eliminado correctamente');
  }

  async alertaError() {
    await this.alertaModalService.error('Error al eliminar el expediente');
  }

  async alertaAdvertencia() {
    await this.alertaModalService.advertencia('Información del expediente');
  }
}
